import React from 'react';
import Fab from '@material-ui/core/Fab';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    fab: {
        position: 'absolute',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
    },
}));

const HelpButton = () => {

    const classes = useStyles();

    const handleClick = () => {
        window.open("https://form.typeform.com/c/AIwHSO2V", "_blank");
    }

    return (
        <Fab 
            className={classes.fab} 
            variant="extended" 
            style={{backgroundColor: "orange"}}
            onClick={handleClick}
        >
            <ContactSupportIcon />
            Need Help
        </Fab>     
    )
}

export default HelpButton;